<template>
  <div class="ui form">
    <div class="ui info message" style="display: block">
      <div class="header">{{ $t("hints for student card id structure") }}</div>
      <ul class="list">
        <li
          v-html="
            $t(
              'use YY to refer the last two digits of year (ex. for 2021 YY means 21)',
            )
          "
        ></li>
        <li
          v-html="$t('use BI to refer the two-digit branch id of logged user')"
        ></li>
        <li v-html="$t('use SEQUENCE to refer to sequenced number')"></li>
      </ul>
    </div>
    <div class="three fields">
      <div class="field">
        <label for="">{{ $t("student card id structure") }}</label>
        <input
          type="text"
          name="student_card_structure"
          v-model="stp.card_structure"
        />
      </div>
      <div class="field">
        <label for="">{{ $t("student card id sequence") }}</label>
        <input
          type="text"
          name="student_card_sequence"
          v-model="stp.card_sequence"
        />
      </div>
      <div class="field">
        <label for="">{{ $t("options") }}</label>
        <div class="ui blue labeled icon button" @click="save">
          <i class="save icon"></i> {{ $t("save") }}
        </div>
      </div>
    </div>
    <div class="field">
      <label for>{{ $t("increase sequence on student creation") }}</label>
      <div class="ui toggle checkbox" ref="increase_sequence_checkbox">
        <input type="checkbox" v-model="stp.increase_sequence" />
        <label>{{ $t("increase sequence") }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";

export default {
  name: "StudentConfigurationModalStudent",
  components: {},
  props: {
    setup: Object,
  },
  data() {
    return {
      stp: {
        card_structure: "",
        card_sequence: "",
        increase_sequence: false,
      },
    };
  },
  methods: {
    save() {
      let vm = this;
      local_api(vm, "post", "/student_configuration/do-save", {
        setup: JSON.stringify(vm.stp),
      })
        .then(() => {
          vm.$alertify.success(vm.$t("student setup saved"));
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.setup && this.setup.std_configuration) {
        this.stp = this.setup.std_configuration;
      }
    }, 500);
  },
};
</script>
